import { Injectable } from '@angular/core'
import { BaseSiteService, ConfigInitializer } from '@spartacus/core'
import { StoreContextConfig } from '../store-context-config'
import { map, take } from 'rxjs/operators'
import { MbBaseSiteCountry } from '../../models'

@Injectable({
  providedIn: 'root'
})
export class CustomStoreContextConfigInitializer implements ConfigInitializer {

  resolveConfig$ = this.baseSiteService.getAll().pipe(
    map(baseSites => baseSites?.find(site => site.fallback)),
    //TODO wadda?
    take(1),
    map(baseSite => this.getConfig(baseSite?.allSites)),
    take(1)
  )
  scopes = ['mbcomstore']
  configFactory = () => this.resolveConfig$.toPromise()

  constructor (protected baseSiteService: BaseSiteService) {
  }

  private getConfig (source?: MbBaseSiteCountry[]) {
    return {
      mbcomstore: {
        sites: source,
      },
    } as StoreContextConfig
  }
}
